// chatbotBubble_slice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../services/apiService';

const chatbotService = apiService('/chatbot');

export const enviarPregunta = createAsyncThunk(
  'chatbot/enviarPregunta',
  async ({ pregunta, id_afiliado }, { rejectWithValue }) => {
    try {
      const response = await chatbotService.createSome('preguntar', JSON.stringify({ pregunta, id_afiliado }));
      return response.respuesta;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const chatbotBubbleSlice = createSlice({
  name: 'chatbotBubble',
  initialState: {
    visible: false,
    pregunta: '',
    respuesta: '',
    status: 'idle',
    error: null
  },
  reducers: {
    mostrarChatbot: (state) => {
      state.visible = true;
    },
    ocultarChatbot: (state) => {
      state.visible = false;
    },
    setPregunta: (state, action) => {
      state.pregunta = action.payload;
    },
    resetRespuesta: (state) => {
      state.respuesta = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(enviarPregunta.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(enviarPregunta.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.respuesta = action.payload;
      })
      .addCase(enviarPregunta.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Error desconocido';
      });
  }
});

export const { mostrarChatbot, ocultarChatbot, setPregunta, resetRespuesta } = chatbotBubbleSlice.actions;
export default chatbotBubbleSlice.reducer;
